import { BadInputError } from '@watershed/errors/BadInputError';
import { stringifyExpr } from '../ast';
import { evalExpression } from '../eval';
import { stringifyType } from '../expr_types';
import { exprToSql } from '../sql';
import { mergeErrors } from '../sql/internal';
import {
  assertArgShape,
  assertNoKwargs,
  typecheckExpression,
} from '../typecheck';
import { Func, SqlExpression } from '../types';
import { safeMaxStage } from '../utils';

export const starts_with: Func = {
  /**
   * starts_with(source: string, suffix: string): boolean
   */
  typecheck(ctx, call, warnings) {
    assertArgShape(call, 2, 2);
    assertNoKwargs(call);

    for (const arg of call.args) {
      const actual = typecheckExpression(ctx, arg, warnings);
      if (actual.ty !== 'string') {
        warnings?.push(
          `Expected "${stringifyExpr(
            arg
          )}" to be a string, but it is a ${stringifyType(actual)}`
        );
      }
    }

    return { ty: 'boolean' };
  },

  eval(ctx, call): boolean {
    const source = evalExpression(ctx, call.args[0]);
    BadInputError.invariant(typeof source === 'string');
    const suffix = evalExpression(ctx, call.args[1]);
    BadInputError.invariant(typeof suffix === 'string');

    return source.startsWith(suffix);
  },

  toSql(ctx, call): SqlExpression {
    const eArgs = call.args.map((arg) => exprToSql(ctx, arg));
    const sqlArgs = eArgs.map(({ expr }) => expr);
    const expr = `prefix(${sqlArgs[0]}, ${sqlArgs[1]})`;

    return {
      expr,
      stage: safeMaxStage(eArgs, 0),
      unitExpr: null,
      error: mergeErrors(eArgs.map((a) => a.error)),
      trace: null,
    };
  },
};
